import React from "react";
import styles from "./SecondBox.module.css";
const SecondBox = () => {
  return (
    <div className="eachpage second">
      <div className="container-on-box">
        <div className={`${styles.maketwocol} ${styles.flexstart}`}>
          <div className={styles.lefttext}>
            <div className={styles.insidetext}>
              We invite you to look different
            </div>
          </div>
          <div className={styles.rightbox}>
            <div className={styles.toptext}>
                طراحی لودینگ اختصاصی
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondBox;
